<template>
  <div class="pa-10">
    <FieldOfficersDataTable />
  </div>
</template>

<script>
import FieldOfficersDataTable from "@/components/Utils/FieldOfficersDataTable.vue";

export default {
  components: {
    FieldOfficersDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
